<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="visible" class="modal-overlay" @click.self="handleClose">
    <div class="modal-popup" :style="popupStyle">
      <div class="modal-content" :style="contentStyle">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  width: {
    type: [String, Number],
    default: "472px",
  },
  height: {
    type: [String, Number],
    default: "auto",
  },
  borderRadius: {
    type: [String, Number],
    default: "50px",
  },
  padding: {
    type: [String, Number],
    default: "24px 36px 28px",
  },
});

const emit = defineEmits(["close"]);

const contentStyle = computed(() => {
  const style = {
    width: typeof props.width === "number" ? `${props.width}px` : props.width,
    borderRadius:
      typeof props.borderRadius === "number"
        ? `${props.borderRadius}px`
        : props.borderRadius,
    padding:
      typeof props.padding === "number" ? `${props.padding}px` : props.padding,
  };
  if (props.height !== "auto") {
    style.height =
      typeof props.height === "number" ? `${props.height}px` : props.height;
  }
  return style;
});

const popupStyle = computed(() => ({
  borderRadius:
    typeof props.borderRadius === "number"
      ? `${props.borderRadius}px`
      : props.borderRadius,
}));

function handleClose() {
  emit("close");
}
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-popup {
  padding: 5px;
  background-color: #7e7c84;
}

.modal-content {
  background-color: #fff;
  box-sizing: border-box;
}
</style>
